import {toNumber} from "lodash";
import {apiSend} from "@util/api";

/**
 * API Post Call specific for the Trial Page in which it sets up
 * the "locations" Array and the "markers" Array for the map
 * to populate the listing and the markers.
 *
 * Using the API response, it maps through the data and creates
 * the markers in order.
 *
 * @param {String} api The API url
 * @param {Object} params The API parameters for the call
 *
 * @returns {Promise<{locations: *, markers: *}>}
 */
export const locationsAndMarkers = async (api, params) => (await apiSend(api, params)
    .then(({data}) => {
        const {locations, postType} = data;

        if (locations) {
            if ( postType === 'programs') return setupProgramMarkers(locations)
            return setupLocationMarkers(locations)
        }

        return {
            locations: [],
            markers: [],
        }
    }))

/**
 * Looks for the index from the store markers array and compares it to the
 * array of HTMLElement pins on the map
 *
 * @param {ComputedRef<[]>} markers The array of store markers
 * @param {String} title The selected pin's title
 *
 * @returns {*}
 */
export const findLocationIndex = (markers, title) => markers.value.findIndex(marker => marker.title === title);

/**
 * Resets the SVG pin marker on the map to the default string
 *
 * @param {String} pinString The SVG string for the pin
 */
export const resetAllPins = (pinString) => {
    const allPins = document.querySelectorAll('[class*="-content-container"]');
    allPins.forEach((pin, index) => index !== 0 && (pin.innerHTML = pinString));
};

export const handlePinSelection = (elm, svg) => {
    const pin = elm.querySelector('[class*="-content-container"]')
    if (pin) pin.innerHTML = svg
}

const setupLocationMarkers = (locations) => (
    {
        locations,
        markers: locations
            .map((location, index) => {
                const {lat, lng} = location?.coords;

                return {
                    index,
                    position: {
                        lat: toNumber(lat),
                        lng: toNumber(lng),
                    },
                    title: location?.facility || '',
                }
            })
    }
)

const setupProgramMarkers = (locations) => {
    const {trials} = PROGRAM

    return {
        locations,
        markers: locations
            .map((location, index) => {
                const {lat, lng} = location?.coords;
                // const nctId = location?.nctid || '';
                /**
                 * Extracts the trial data from the defined trials to grab locations for
                 */
                // const trialData = trials.filter(data => data.title === nctId)[0]

                return {
                    index,
                    position: {
                        lat: toNumber(lat),
                        lng: toNumber(lng),
                    },
                    title: location?.facility || '',
                }
            })
    }
}
